module.exports = __webpack_public_path__ + "static/media/iconSix.19d178e5.svg";